/**
 * @generated SignedSource<<5a51142d0d1bfe2711da22a2558e74d1>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type ViewFormDialog_user$data = {
  readonly account: {
    readonly id: number;
    readonly user_accounts: ReadonlyArray<{
      readonly id: number;
      readonly user: {
        readonly email: string;
        readonly first_name: string | null | undefined;
        readonly id: number;
        readonly image_key: string | null | undefined;
        readonly last_name: string | null | undefined;
        readonly permissions: any;
      };
    }>;
  };
  readonly id: number;
  readonly " $fragmentSpreads": FragmentRefs<"ViewFilterValues_user">;
  readonly " $fragmentType": "ViewFormDialog_user";
};
export type ViewFormDialog_user$key = {
  readonly " $data"?: ViewFormDialog_user$data;
  readonly " $fragmentSpreads": FragmentRefs<"ViewFormDialog_user">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "argumentDefinitions": [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "peopleFilter"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "projectsFilter"
    }
  ],
  "kind": "Fragment",
  "metadata": null,
  "name": "ViewFormDialog_user",
  "selections": [
    (v0/*: any*/),
    {
      "alias": null,
      "args": null,
      "concreteType": "accounts",
      "kind": "LinkedField",
      "name": "account",
      "plural": false,
      "selections": [
        (v0/*: any*/),
        {
          "alias": null,
          "args": null,
          "concreteType": "user_accounts",
          "kind": "LinkedField",
          "name": "user_accounts",
          "plural": true,
          "selections": [
            (v0/*: any*/),
            {
              "alias": null,
              "args": null,
              "concreteType": "users",
              "kind": "LinkedField",
              "name": "user",
              "plural": false,
              "selections": [
                (v0/*: any*/),
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "first_name",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "last_name",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "email",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "image_key",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "permissions",
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "args": [
        {
          "kind": "Variable",
          "name": "peopleFilter",
          "variableName": "peopleFilter"
        },
        {
          "kind": "Variable",
          "name": "projectsFilter",
          "variableName": "projectsFilter"
        }
      ],
      "kind": "FragmentSpread",
      "name": "ViewFilterValues_user"
    }
  ],
  "type": "users",
  "abstractKey": null
};
})();

(node as any).hash = "6477c2ada545a39a37db55403d6d4376";

export default node;
